import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { FOOTER_HEIGHT_CSS_VAR } from './constants';
import { useTrackElementHeightVar } from './use-track-element-height';

const footerStyles = css`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: ${theme.colors.white};
  box-shadow: ${theme.shadows.floating};
  z-index: 999;
`;

const contentContainerStyle = css`
  display: flex;
  flex-direction: row;
  max-width: 700px;
  padding: ${theme.spacing(1.5, 3)};
  margin: 0 auto;
`;

const submitButtonStyles = css`
  margin-left: auto;
`;

interface Props {
  showPreviousButton?: boolean;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  isSubmitting?: boolean;
  previousButtonText?: string;
  nextButtonText?: string;
  onPreviousClick: () => void;
}

export const FormActionsFooter = ({
  showPreviousButton,
  prevDisabled,
  nextDisabled,
  isSubmitting,
  previousButtonText,
  nextButtonText,
  onPreviousClick,
}: Props) => {
  const footerRef = useTrackElementHeightVar(FOOTER_HEIGHT_CSS_VAR);

  return (
    <footer ref={footerRef} css={footerStyles}>
      <div css={contentContainerStyle}>
        {showPreviousButton && (
          <Button variant='secondary' disabled={prevDisabled || isSubmitting} onClick={onPreviousClick} type='button'>
            {previousButtonText}
          </Button>
        )}
        <Button css={submitButtonStyles} type='submit' disabled={nextDisabled} loading={isSubmitting}>
          {nextButtonText}
        </Button>
      </div>
    </footer>
  );
};
